var _defs, _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCall = function SvgCall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Llamada")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Modelo2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.69,28a7.38,7.38,0,0,1-2.49-.44,26.65,26.65,0,0,1-9.62-6.14A26.65,26.65,0,0,1,2.44,11.8a7.27,7.27,0,0,1,.89-6.67A7.34,7.34,0,0,1,5.87,2.87,7.17,7.17,0,0,1,9.33,2a.82.82,0,0,1,.8.64L11.4,8.59a.81.81,0,0,1-.22.75L9,11.52A21.51,21.51,0,0,0,18.48,21l2.18-2.18a.81.81,0,0,1,.75-.22l5.95,1.27a.82.82,0,0,1,.64.8,7.17,7.17,0,0,1-.87,3.46,7.34,7.34,0,0,1-2.26,2.54,7.23,7.23,0,0,1-3.13,1.25,7.42,7.42,0,0,1-1,.08ZM8.68,3.66a5.63,5.63,0,0,0-4,2.4A5.57,5.57,0,0,0,4,11.24,24.6,24.6,0,0,0,18.76,26a5.7,5.7,0,0,0,7.58-4.71l-4.84-1-2.28,2.27a.79.79,0,0,1-.92.16,23,23,0,0,1-11-11,.79.79,0,0,1,.16-.92L9.72,8.5Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.19,15.81a.82.82,0,0,1-.82-.81A11.39,11.39,0,0,0,15,3.62.81.81,0,0,1,15,2,13,13,0,0,1,28,15a.81.81,0,0,1-.81.81Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.94,15.81a.81.81,0,0,1-.81-.81A8.14,8.14,0,0,0,15,6.87a.81.81,0,0,1,0-1.62A9.76,9.76,0,0,1,24.75,15a.81.81,0,0,1-.81.81Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.69,15.81a.81.81,0,0,1-.81-.81A4.89,4.89,0,0,0,15,10.12.81.81,0,1,1,15,8.5,6.51,6.51,0,0,1,21.5,15a.81.81,0,0,1-.81.81Zm0,0"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/call.70025caa.svg";
export { ForwardRef as ReactComponent };